import styled from 'styled-components';
import TopNav from "./TopNav";
import { P2 } from './Typography';
import { selectUser } from '../common/slices/user';
import { useSelector } from 'react-redux';
import nodePackage from '../../package.json'

export const Content = styled.div`
    padding: 0 1rem;
    padding-bottom: 1rem;
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    align-self: stretch;
    // overflow: auto;
`

const Layout = ({ children }) => {
    const user = useSelector(selectUser);

    return (
        <>
            <TopNav visible={!!user} />
            <Content>
                {children}
                <P2 style={{ marginTop: 'auto', paddingBottom: 0, marginBottom: 0, textAlign: 'center' }}>&copy; {new Date().getFullYear()} United Roofing ({nodePackage.version})</P2>
            </Content>
        </>
    );
};

export default Layout;